// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6800 ? "4bf53aa9" : chunkId) + "." + {"1303":"aa5173192251cc35","2415":"a0b583ba6f9bac13","3618":"d1c68aa992b604d9","6800":"16c0126033095866","7071":"73fb494f5487e16c"}[chunkId] + ".js";
};